import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Form, Card, Button, Input, Steps, Upload,
  Select, message, Spin, AutoComplete,
} from "antd";
import {
  MobileOutlined, LockOutlined, UserOutlined,
  CheckCircleOutlined, HeartFilled, SafetyOutlined,
  StarFilled, CameraOutlined, ArrowRightOutlined,
  CheckCircleFilled, GiftOutlined, ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  User_send_otp, User_verify_otp, UserRegUpdate,
  UserDataPostwt, User_StateGet, User_CasteGet,
  getUserProfileId, getDistrictsByState, getCitiesByDistrict,
  checkUsernameAvailability, validateReferralCode, getReligionOptions, checkEmailAvailability
} from "../../Api/CoreApi";
import {
  Hindu, Muslim, MuslimShia, MuslimSunni,
  Christian, Sikh, JainDigambar, JainShwetambar,
  Parsi, Buddhist, Jewish, InterReligion, NoReligiousBelief
} from 'indian-religion-caste';
import LoginHeader from "../../Home_Page_WLog/LoginHeader/LoginHeader";
import Footer from "../../Home_Page_WLog/Footer/Footer";
import Swal from "sweetalert2";
import "./Registration.css";

const { Option } = Select;

function User_Reg() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryRef = queryParams.get("ref");

  const [userData, setUserData] = useState({});
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [filteredCastes, setFilteredCastes] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');

  const [emailStatus, setEmailStatus] = useState({
    checking: false,
    validated: false,
    available: true,
    message: "",
  });

  const reid = useParams();
  const urlRef = queryRef || reid.id || "";
  const referralSource = queryRef ? "referral_link" : reid.id ? "referral_link" : "";

  const [phoneForm] = Form.useForm();
  const [otpForm] = Form.useForm();
  const [usernameForm] = Form.useForm();
  const [profileForm] = Form.useForm();

  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [phone_pop, setPhone_pop] = useState(0);
  const [state, setState] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [subCourses, setSubCourses] = useState([]);
  const [isOtherCourse, setIsOtherCourse] = useState(false);
  const [otherSubCourse, setOtherSubCourse] = useState('');
  const [religionOptions, setReligionOptions] = useState([]);
  const [formProgress, setFormProgress] = useState(0);

  const [usernameStatus, setUsernameStatus] = useState({
    checking: false,
    available: false,
    message: '',
    validated: false,
  });

  const [referralStatus, setReferralStatus] = useState({
    checking: false,
    valid: false,
    message: '',
    validated: false,
    referrerData: null,
  });

  const generateHeightOptions = () => {
    const heights = [];
    for (let feet = 4; feet <= 8; feet++) {
      const maxInches = feet === 8 ? 0 : 11;
      for (let inches = 0; inches <= maxInches; inches++) {
        const totalCm = Math.round((feet * 30.48) + (inches * 2.54));
        const label = `${feet}'${inches}" (${totalCm} cm)`;
        const value = `${feet}'${inches}"`;
        heights.push({ label, value, feet, inches, cm: totalCm });
      }
    }
    return heights;
  };

  const occupationOptions = [
    "Government Employee", "Private Employee", "Business",
    "Self-Employed", "Farmer", "Teacher", "Doctor", "Engineer",
    "Lawyer", "Architect", "Banker", "CA", "Professor",
    "Retired", "Housewife", "Other"
  ];

  const fatherOccupationOptions = occupationOptions.filter(
    option => option !== "Housewife"
  );

  const subCourseData = {
    "10th": ["Science", "Commerce", "Arts", "Sanskrit", "General"],
    "12th": ["Science (PCM)", "Science (PCB)", "Science (PCMB)", "Commerce with Maths", "Commerce without Maths", "Arts / Humanities", "Vocational", "Home Science", "Agriculture"],
    "Diploma": ["Civil Engineering", "Mechanical Engineering", "Electrical Engineering", "Electronics Engineering", "Computer Engineering", "Information Technology", "Automobile Engineering", "Chemical Engineering", "Mining Engineering", "Textile Engineering", "Fashion Design", "Interior Design", "Pharmacy (D.Pharm)", "Nursing (GNM/ANM)", "Hotel Management", "Photography", "Animation", "Graphic Design", "Agriculture", "Other"],
    "ITI": ["Fitter", "Electrician", "Welder", "Plumber", "Carpenter", "Mechanic (Motor Vehicle)", "Mechanic (Diesel)", "Turner", "Machinist", "Wireman", "Refrigeration & AC", "Draughtsman (Civil)", "Draughtsman (Mechanical)", "Surveyor", "Stenographer", "COPA (Computer Operator)", "Painter", "Tailor", "Sheet Metal Worker", "Foundryman", "Other"],
    "B.Sc": ["Physics", "Chemistry", "Mathematics", "Biology", "Botany", "Zoology", "Biotechnology", "Microbiology", "Biochemistry", "Genetics", "Environmental Science", "Computer Science", "IT", "Data Science", "Agriculture", "Nursing", "Other"],
    "M.Sc": ["Physics", "Chemistry", "Mathematics", "Biology", "Biotechnology", "Computer Science", "Data Science", "AI & ML", "Cyber Security", "Other"],
    "Ph.D": ["Physics", "Chemistry", "Mathematics", "Biology", "Computer Science", "Management", "Economics", "Engineering", "Medicine", "Other"],
    "B.Tech": ["Computer Science Engineering (CSE)", "Information Technology (IT)", "Electronics & Communication (ECE)", "Electrical & Electronics (EEE)", "Mechanical Engineering", "Civil Engineering", "Chemical Engineering", "AI & ML", "Data Science", "Cyber Security", "Other"],
    "B.E.": ["Computer Science Engineering", "Information Technology", "Electronics & Communication", "Mechanical Engineering", "Civil Engineering", "Chemical Engineering", "Other"],
    "M.Tech": ["Computer Science", "Electronics & Communication", "Mechanical Engineering", "Civil Engineering", "AI & ML", "Data Science", "Cyber Security", "Other"],
    "M.E.": ["Computer Science", "Electronics & Communication", "Mechanical Engineering", "Civil Engineering", "Other"],
    "MBBS": ["General Medicine", "Surgery", "Pediatrics", "Other"],
    "MD/MS": ["MD General Medicine", "MS General Surgery", "Other"],
    "BDS": ["Oral Medicine", "Oral Surgery", "Other"],
    "MDS": ["Oral Surgery", "Periodontics", "Other"],
    "BAMS": ["Kaya Chikitsa", "Panchakarma", "Other"],
    "BHMS": ["Homeopathy General", "Other"],
    "BUMS": ["Unani General Medicine", "Other"],
    "BPT": ["Orthopedic Physiotherapy", "Neurological", "Other"],
    "MPT": ["Orthopedics", "Neurology", "Other"],
    "B.Pharm": ["Pharmaceutics", "Pharmacology", "Other"],
    "M.Pharm": ["Pharmaceutics", "Pharmacology", "Clinical Pharmacy", "Other"],
    "Nursing (B.Sc/M.Sc)": ["General Nursing", "Midwifery", "Critical Care", "Other"],
    "B.Com": ["General", "Accountancy", "Finance", "Banking & Insurance", "Taxation", "Marketing", "E-Commerce", "Other"],
    "M.Com": ["Accountancy", "Finance", "Banking", "Taxation", "Other"],
    "CA": ["Financial Accounting", "Auditing", "Direct Tax", "Indirect Tax (GST)", "Other"],
    "CS": ["Company Law", "Corporate Law", "Secretarial Practice", "Other"],
    "CMA": ["Cost Accounting", "Management Accounting", "Other"],
    "BBA": ["General Management", "Marketing", "Finance", "HR", "Other"],
    "MBA": ["Marketing", "Finance", "HR", "Operations", "IT", "International Business", "Business Analytics", "Digital Marketing", "Healthcare Management", "Other"],
    "PGDM": ["Marketing", "Finance", "HR", "Operations", "IT", "Other"],
    "BCA": ["General", "Web Development", "Mobile App", "Cyber Security", "Other"],
    "MCA": ["Software Engineering", "Data Science", "AI & ML", "Cyber Security", "Other"],
    "BA": ["English", "Hindi", "History", "Political Science", "Economics", "Psychology", "Sociology", "Journalism", "Fine Arts", "Music", "Other"],
    "MA": ["English", "Hindi", "History", "Political Science", "Economics", "Psychology", "Sociology", "Other"],
    "B.Ed": ["Mathematics", "Science", "English", "Hindi", "Social Studies", "Other"],
    "M.Ed": ["Educational Leadership", "Educational Psychology", "Other"],
    "D.Ed / D.El.Ed": ["Elementary Education", "Primary Education", "Other"],
    "LLB": ["Constitutional Law", "Criminal Law", "Civil Law", "Corporate Law", "Other"],
    "LLM": ["Constitutional Law", "Criminal Law", "Corporate Law", "Other"],
    "BA LLB": ["Integrated Law (5 Years)", "Corporate Law", "Other"],
    "Design": ["Graphic Design", "UI/UX Design", "Fashion Design", "Interior Design", "Product Design", "Animation", "Web Design", "Other"],
    "Hotel Management": ["Front Office", "Housekeeping", "Food Production", "Food & Beverage Service", "Culinary Arts", "Other"],
    "Mass Communication / Journalism": ["Print Journalism", "Broadcast Journalism", "Digital Journalism", "Public Relations", "Advertising", "Other"],
    "B.Sc Agriculture": ["Agronomy", "Horticulture", "Soil Science", "Plant Pathology", "Other"],
    "M.Sc Agriculture": ["Agronomy", "Horticulture", "Soil Science", "Agri-Business", "Other"],
    "BFA / MFA (Fine Arts)": ["Painting", "Sculpture", "Applied Arts", "Photography", "Other"],
    "Music / Dance": ["Hindustani Classical Vocal", "Carnatic Vocal", "Instrumental Music", "Bharatanatyam", "Kathak", "Contemporary Dance", "Other"],
    "Aviation": ["Commercial Pilot Training", "Aircraft Maintenance", "Cabin Crew", "Other"],
    "Merchant Navy": ["Nautical Science", "Marine Engineering", "Other"],
    "Defence": ["NDA", "CDS", "AFCAT", "Other"],
    "Other": ["Other Subjects / Specialization"]
  };

  const HEIGHT_OPTIONS = generateHeightOptions();
  const heightOptions = HEIGHT_OPTIONS.map(h => ({ value: h.value, label: h.label }));
  const bloodGroupOptions = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
  const motherTongueOptions = ["Hindi", "English", "Marathi", "Punjabi", "Gujarati", "Bengali", "Tamil", "Telugu", "Kannada", "Malayalam", "Odia", "Urdu"];
  const courseOptions = ["10th", "12th", "B.Sc", "M.Sc", "B.Tech", "MBBS", "B.Com", "M.Com", "MBA", "BCA", "MCA", "BA", "MA", "B.Ed", "LLB", "Ph.D", "Diploma", "ITI", "Other"];

  useEffect(() => {
    User_CasteGet().catch(() => { });
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const loadStates = async () => {
      try {
        setIsLoading(true);
        const res = await User_StateGet();
        if (Array.isArray(res)) setState(res);
        else if (res?.data) setState(res.data);
        else setState([]);
      } catch {
        setState([]);
      } finally {
        setIsLoading(false);
      }
    };
    loadStates();
  }, []);

  useEffect(() => {
    const autoValidate = async () => {
      if (queryRef) {
        profileForm.setFieldsValue({ referral_code: queryRef });
        localStorage.setItem("pending_referral", queryRef);
        await validateReferral(queryRef);
      } else if (reid.id) {
        profileForm.setFieldsValue({ referral_code: reid.id });
        await validateReferral(reid.id);
      } else {
        profileForm.setFieldsValue({ referral_code: "" });
        setReferralStatus({
          checking: false,
          valid: false,
          message: '',
          validated: true,
          referrerData: null,
        });
      }
    };
    autoValidate();
  }, [queryRef, reid.id]);

  useEffect(() => {
    const loadReligions = async () => {
      try {
        const res = await getReligionOptions();
        const religions = res?.religions || [];
        if (religions.length > 0) {
          setReligionOptions(religions);
        }
      } catch (error) {
        console.error("❌ Failed:", error);
      }
    };
    loadReligions();
  }, []);

  const calculateProgress = useCallback(() => {
    if (phone_pop !== 3) return;
    const values = profileForm.getFieldsValue();
    const fields = [
      { key: 'firstname', weight: 10 },
      { key: 'gender', weight: 8 },
      { key: 'dob', weight: 8 },
      { key: 'state', weight: 6 },
      { key: 'disttrict', weight: 4 },
      { key: 'city', weight: 4 },
      { key: 'religion', weight: 8 },
      { key: 'caste', weight: 8 },
      { key: 'father_name', weight: 5 },
      { key: 'mother_name', weight: 5 },
      { key: 'course', weight: 6 },
      { key: 'job_title', weight: 5 },
      { key: 'marrige_status', weight: 5 },
      { key: 'height', weight: 3 },
      { key: 'mother_tongue', weight: 3 },
      { key: 'email', weight: 3 },
      { key: 'contact1', weight: 2 },
      { key: 'blood_group', weight: 2 },
      { key: 'annual_income', weight: 3 },
      { key: 'additional_notes', weight: 2 },
    ];
    const photoWeight = 5;
    let totalWeight = photoWeight;
    let filledWeight = file ? photoWeight : 0;

    fields.forEach(f => {
      totalWeight += f.weight;
      const val = values[f.key];
      if (val !== undefined && val !== null && val !== '' && val !== 0) {
        filledWeight += f.weight;
      }
    });

    setFormProgress(Math.round((filledWeight / totalWeight) * 100));
  }, [phone_pop, file, profileForm]);

  const getReligionIcon = (religion) => {
    const icons = {
      'Hindu': '🕉️', 'Muslim': '🕌', 'MuslimShia': '🕌',
      'MuslimSunni': '🕌', 'Christian': '⛪', 'Sikh': '🪯',
      'Jain': '✋', 'JainDigambar': '✋', 'JainShwetambar': '✋',
      'Buddhist': '☸️', 'Parsi': '🔥', 'Jewish': '✡️',
      'InterReligion': '🤝', 'NoReligiousBelief': '🌿'
    };
    return icons[religion] || '🔯';
  };

  const checkUsername = async (username) => {
    if (!username || username.length < 3) {
      setUsernameStatus({ checking: false, available: false, message: 'Min 3 characters', validated: false });
      return;
    }
    if (!/^[a-z0-9]+$/.test(username)) {
      setUsernameStatus({ checking: false, available: false, message: 'Only lowercase alphanumeric', validated: false });
      return;
    }
    setUsernameStatus({ checking: true, available: false, message: 'Checking...', validated: false });
    try {
      const response = await checkUsernameAvailability(username);
      if (response?.available) {
        setUsernameStatus({ checking: false, available: true, message: '✅ Available!', validated: true });
      } else {
        setUsernameStatus({ checking: false, available: false, message: '❌ Already exists!', validated: true });
      }
    } catch {
      setUsernameStatus({ checking: false, available: false, message: '⚠️ Could not verify.', validated: false });
    }
    usernameForm.validateFields(['username']).catch(() => { });
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value.toLowerCase();
    usernameForm.setFieldsValue({ username: value });
    setUsernameStatus({ checking: false, available: false, message: 'Checking...', validated: false });
    clearTimeout(window.usernameTimeout);
    window.usernameTimeout = setTimeout(() => checkUsername(value), 600);
  };

  const handleStateChange = async (value) => {
    setSelectedState(value);
    setDistricts([]);
    setCities([]);
    profileForm.setFieldsValue({ disttrict: undefined, city: undefined });
    if (!value) return;
    try {
      const response = await getDistrictsByState(value);
      setDistricts(response?.districts || (Array.isArray(response) ? response : []));
    } catch { message.error("Failed to load districts"); }
  };

  const validateReferral = async (code) => {
    if (!code || code.trim().length === 0) {
      setReferralStatus({ checking: false, valid: false, message: '', validated: true, referrerData: null });
      return;
    }
    const cleanCode = code.trim();
    const isNumeric = /^\d+$/.test(cleanCode);
    const isCRCode = /^CR\d+$/i.test(cleanCode);
    if (!isNumeric && !isCRCode) {
      setReferralStatus({ checking: false, valid: false, message: '⚠️ Invalid format. Use numeric code or CR code', validated: true, referrerData: null });
      return;
    }
    setReferralStatus({ checking: true, valid: false, message: '⏳ Checking referral code...', validated: false, referrerData: null });
    try {
      const response = await validateReferralCode(cleanCode);
      if (response?.valid) {
        setReferralStatus({ checking: false, valid: true, message: response.message || '✅ Valid referral code!', validated: true, referrerData: response.referrer || null });
        const isFromUrl = (queryRef === cleanCode) || (reid.id === cleanCode);
        if (!isFromUrl) message.success('✅ Valid referral code!');
      } else {
        const isFromUrl = (queryRef === cleanCode) || (reid.id === cleanCode);
        if (isFromUrl) {
          setReferralStatus({ checking: false, valid: false, message: '⚠️ Referral code could not be verified', validated: true, referrerData: null });
        } else {
          setReferralStatus({ checking: false, valid: false, message: response.message || '❌ Invalid referral code', validated: true, referrerData: null });
          message.error('❌ Invalid referral code');
        }
      }
    } catch (error) {
      const isFromUrl = (queryRef === cleanCode) || (reid.id === cleanCode);
      setReferralStatus({ checking: false, valid: isFromUrl, message: isFromUrl ? '✅ Referral code accepted' : '⚠️ Error checking code', validated: true, referrerData: null });
    }
  };

  const handleReferralChange = (e) => {
    const value = e.target.value;
    profileForm.setFieldsValue({ referral_code: value });
    setReferralStatus({ checking: false, valid: false, message: '', validated: false, referrerData: null });
    clearTimeout(window.referralTimeout);
    window.referralTimeout = setTimeout(() => validateReferral(value), 800);
  };

  const handleDistrictChange = async (value) => {
    setSelectedDistrict(value);
    setCities([]);
    profileForm.setFieldsValue({ city: undefined });
    if (!value) return;
    try {
      const response = await getCitiesByDistrict(value);
      setCities(response?.cities || (Array.isArray(response) ? response : []));
    } catch { setCities([]); }
  };

  const emailTimerRef = useRef(null);
  const handleEmailChange = (e) => {
    const value = e.target.value;
    if (emailTimerRef.current) clearTimeout(emailTimerRef.current);
    if (!value || !value.trim()) {
      setEmailStatus({ checking: false, validated: false, available: true, message: "" });
      return;
    }
    emailTimerRef.current = setTimeout(async () => {
      setEmailStatus({ checking: true, validated: false, available: true, message: "" });
      try {
        const response = await checkEmailAvailability(value);
        if (response.available) {
          setEmailStatus({ checking: false, validated: true, available: true, message: "" });
        } else {
          setEmailStatus({ checking: false, validated: true, available: false, message: "❌ Email already registered" });
        }
      } catch {
        setEmailStatus({ checking: false, validated: false, available: true, message: "" });
      }
    }, 500);
  };

  const handleCourseChange = (value) => {
    setSelectedCourse(value);
    setSubCourses([]);
    setOtherSubCourse('');
    profileForm.setFieldsValue({ sub_course: undefined });
    if (!value) { setIsOtherCourse(false); return; }
    if (value === 'Other') { setIsOtherCourse(true); return; }
    setIsOtherCourse(false);
    setSubCourses(subCourseData[value] || []);
  };

  const handlereligionChange = (value) => {
    setFilteredCastes([]);
    profileForm.setFieldsValue({ caste: undefined, subcaste: undefined });
    if (!value) return;
    const casteMap = {
      'Hindu': Hindu, 'Muslim': MuslimShia, 'MuslimShia': MuslimShia, 'MuslimSunni': MuslimSunni,
      'Christian': Christian, 'Sikh': Sikh, 'Jain': JainDigambar, 'JainDigambar': JainDigambar,
      'JainShwetambar': JainShwetambar, 'Buddhist': Buddhist, 'Parsi': Parsi, 'Jewish': Jewish,
      'InterReligion': InterReligion, 'NoReligiousBelief': NoReligiousBelief,
    };
    setFilteredCastes(casteMap[value] || []);
  };

  const send = async (value) => {
    setIsLoading(true);
    try {
      if (!value.contact || value.contact.length !== 10) {
        message.error("Please enter a valid 10-digit mobile number");
        setIsLoading(false);
        return;
      }
      await User_send_otp(value);
      setUserData((prev) => ({ ...prev, contact: value.contact }));
      message.success("✅ OTP sent successfully!");
      setPhone_pop(1);
      otpForm.setFieldsValue({ contact: value.contact });
    } catch (error) {
      if (error.already_registered) {
        Swal.fire({
          title: '⚠️ Mobile Number Already Registered',
          html: `
          <div style="text-align: left; padding: 8px 0;">
            <p style="color: #555; font-size: 15px; margin-bottom: 10px;">This mobile number is already registered with us.</p>
            <div style="background: #f5f5f5; padding: 12px; border-radius: 10px; text-align: center; margin: 10px 0;">
              <span style="font-size: 18px; font-weight: 700; color: #ff0055;">${value.contact}</span>
            </div>
            <p style="color: #888; font-size: 13px; margin-top: 8px;">Please login to continue or use forgot password.</p>
          </div>
        `,
          icon: 'warning', showCancelButton: true, confirmButtonColor: '#ff0055',
          cancelButtonColor: '#888', confirmButtonText: '🔑 Login Now', cancelButtonText: '📝 Try Another',
          backdrop: 'rgba(255,0,85,0.08)', customClass: { popup: 'swal2-popup-custom' }
        }).then((result) => {
          if (result.isConfirmed) navigate('/User_Login');
          else { phoneForm.setFieldsValue({ contact: '' }); setTimeout(() => document.querySelector('input[name="contact"]')?.focus(), 100); }
        });
      } else {
        const errorMsg = error.response?.data?.error || error.response?.data?.message || "Failed to send OTP. Please try again.";
        message.error(errorMsg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const verify = async (value) => {
    setIsLoading(true);
    try {
      const response = await User_verify_otp(value);
      if (response?.user_id) {
        localStorage.setItem("user_id", response.user_id);
        setUserData((prev) => ({ ...prev, contact: value.contact }));
        setPhone_pop(2);
        message.success("✅ Phone verified!");
      } else message.error("Invalid response from server");
    } catch (error) {
      message.error(error.response?.data?.error || "Invalid OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUsernameSubmit = async (value) => {
    if (!usernameStatus.available) { message.error("Please choose an available username"); return; }
    setIsLoading(true);
    try {
      const userId = localStorage.getItem("user_id");
      if (!userId) { message.error("User ID not found."); return; }
      setUserData((prev) => ({ ...prev, username: value.username }));
      await UserRegUpdate(userId, { username: value.username, password: value.password, contact: userData.contact });
      localStorage.setItem("username", value.username);
      setPhone_pop(3);
      message.success("Account created! Now complete your profile.");
    } catch (error) {
      message.error(error.response?.data?.username?.[0] || "Username already exists.");
    } finally {
      setIsLoading(false);
    }
  };

  const profile_details = async (value) => {
    setIsLoading(true);
    try {
      const userId = localStorage.getItem("user_id");
      if (!userId) { message.error("User ID not found. Please register again."); setIsLoading(false); return; }

      const inputReferralCode = value.referral_code?.trim() || '';
      if (inputReferralCode) {
        if (referralStatus.checking) { message.warning('⏳ Please wait, validating referral code...'); setIsLoading(false); return; }
        if (!referralStatus.validated) { message.info('⏳ Validating referral code...'); setIsLoading(false); await validateReferral(inputReferralCode); return; }
        const isFromUrl = (queryRef === inputReferralCode) || (reid.id === inputReferralCode);
        if (!referralStatus.valid && !isFromUrl) { message.error('❌ Invalid referral code. Please check and try again.'); setIsLoading(false); return; }
      }

      let age = null;
      if (value.dob) {
        const d = new Date(value.dob); const t = new Date();
        age = t.getFullYear() - d.getFullYear();
        const m = t.getMonth() - d.getMonth();
        if (m < 0 || (m === 0 && t.getDate() < d.getDate())) age--;
      }

      const formReferral = value.referral_code?.trim() || "";
      const urlReferral = queryRef?.trim() || "";
      const routeReferral = reid.id?.trim() || "";
      const referralCode = referralStatus.valid ? (formReferral || urlReferral || routeReferral) : "";

      let addedMethod = "self";
      let addedByType = referralStatus.referrerData?.role || "self";
      if (referralCode) {
        addedMethod = (urlReferral || routeReferral) ? "referral_link" : "referral_code";
      }

      const usernameVal = userData.username || "";
      const district = value.district || value.disttrict || "";

      const profileData = new FormData();
      profileData.append("user_id", userId);
      if (usernameVal) profileData.append("username", usernameVal);
      if (value.firstname) profileData.append("firstname", value.firstname);
      if (value.gender) profileData.append("gender", value.gender);
      if (district) profileData.append("district", district);
      if (value.state) profileData.append("state", value.state);
      if (value.city) profileData.append("city", value.city);
      if (value.country) profileData.append("country", value.country);
      profileData.append("role", "user");
      if (value.caste) profileData.append("caste", value.caste);
      if (value.subcaste) profileData.append("subcaste", value.subcaste);
      if (value.religion) profileData.append("religion", value.religion);
      if (value.email) profileData.append("email", value.email);
      if (userData.contact) profileData.append("contact", userData.contact);
      if (value.contact1) profileData.append("contact1", value.contact1);
      if (value.dob) profileData.append("dob", value.dob);
      if (age !== null) profileData.append("age", String(age));
      if (value.father_name) profileData.append("father_name", value.father_name);
      if (value.mother_name) profileData.append("mother_name", value.mother_name);
      if (value.father_occupation) profileData.append("father_occupation", value.father_occupation);
      if (value.mother_occupation) profileData.append("mother_occupation", value.mother_occupation);
      profileData.append("brother", String(value.brother || 0));
      profileData.append("brother_marrige", String(value.brother_marrige || 0));
      profileData.append("sister", String(value.sister || 0));
      profileData.append("sister_marrige", String(value.sister_marrige || 0));
      if (value.university) profileData.append("university", value.university);
      if (value.course) profileData.append("course", value.course);
      if (value.sub_course) profileData.append("sub_course", value.sub_course);
      if (value.job_title) profileData.append("job_title", value.job_title);
      if (value.job_type) profileData.append("job_type", value.job_type);
      if (value.Lifestyle) profileData.append("Lifestyle", value.Lifestyle);
      if (value.annual_income) profileData.append("annual_income", String(value.annual_income));
      if (value.marrige_status) profileData.append("marrige_status", value.marrige_status);
      if (value.mother_tongue) profileData.append("mother_tongue", value.mother_tongue);
      if (value.height) profileData.append("height", value.height);
      if (value.blood_group) profileData.append("blood_group", value.blood_group);
      if (value.created_profile) profileData.append("created_profile", value.created_profile);
      if (value.additional_notes) profileData.append("additional_notes", value.additional_notes);
      if (referralCode) { profileData.append("refer", referralCode); profileData.append("referral_code", referralCode); }
      if (file) profileData.append("pic", file);

      try {
        const userUpdateData = new FormData();
        userUpdateData.append("first_name", value.firstname || "");
        userUpdateData.append("username", usernameVal);
        userUpdateData.append("gender", value.gender || "");
        userUpdateData.append("district", district);
        userUpdateData.append("state", value.state || "");
        userUpdateData.append("caste", value.caste || "");
        userUpdateData.append("religion", value.religion || "");
        userUpdateData.append("email", value.email || "");
        userUpdateData.append("contact", userData.contact || "");
        userUpdateData.append("added_by_type", addedByType);
        userUpdateData.append("added_method", addedMethod);
        if (referralCode) userUpdateData.append("refer_by", referralCode);
        if (file) userUpdateData.append("pic", file);
        await UserRegUpdate(userId, userUpdateData);
      } catch (userError) { }

      const response = await UserDataPostwt(profileData);
      message.success("🎉 Registration Successful!");

      let profileId = null;
      if (response?.profile_id) profileId = response.profile_id;
      else profileId = await getUserProfileId(userId);
      if (!profileId) profileId = `CR${String(parseInt(userId) || 1).padStart(6, '0')}`;
      if (profileId) {
        profileId = profileId.replace(/O/g, '0');
        if (!profileId.startsWith('CR')) profileId = `CR${profileId.replace(/\D/g, '').padStart(6, '0')}`;
      }

      Swal.fire({
        title: '🎉 Registration Successful!',
        html: `
        <div style="padding: 10px 0;">
          <p style="color: #888; font-size: 14px; margin-bottom: 8px;">Your Profile ID:</p>
          <h2 style="color: #ff0055; font-size: 32px; font-weight: 800; 
                     letter-spacing: 2px; background: linear-gradient(135deg, #fff0f3, #ffe4ec);
                     padding: 12px 24px; border-radius: 12px; display: inline-block;">
            ${profileId || 'CR000001'}
          </h2>
          ${referralCode && referralStatus.valid
            ? `<div style="margin-top:12px;padding:10px;background:#e8f5e9;border-radius:8px;">
                <p style="color:#2e7d32;font-size:13px;margin:0;font-weight:600;">✅ Referred by: <strong>${referralCode}</strong></p>
              </div>`
            : `<p style="color:#888;font-size:13px;margin-top:8px;">👤 Self Registration</p>`
          }
        </div>
      `,
        icon: 'success', confirmButtonColor: '#ff0055', confirmButtonText: 'Go to Login',
        showCancelButton: true, cancelButtonColor: '#888',
        didOpen: () => {
          window.copyProfileId = (text) => {
            navigator.clipboard.writeText(text).then(() => { Swal.fire({ title: '📋 Copied!', text: 'Profile ID copied to clipboard', icon: 'success', timer: 1500, showConfirmButton: false }); });
          };
        }
      }).then((result) => {
        if (result.isConfirmed) navigate('/User_Login');
        else if (result.dismiss === Swal.DismissReason.cancel) navigate('/Profile');
      });
    } catch (error) {
      message.error(error.message || "Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleProfileFinishFailed = (errorInfo) => {
    if (errorInfo.outOfDate) { profileForm.submit(); return; }
    if (errorInfo.errorFields.length === 0) { profileForm.submit(); return; }
    message.error(`Please fix ${errorInfo.errorFields.length} error(s) in the form`);
    profileForm.scrollToField(errorInfo.errorFields[0].name, { behavior: 'smooth', block: 'center' });
  };

  const stepTitles = [
    { icon: <MobileOutlined />, title: "Enter Mobile", desc: "Begin your journey to find your life partner" },
    { icon: <SafetyOutlined />, title: "Verify OTP", desc: "Enter the code sent to your mobile" },
    { icon: <LockOutlined />, title: "Create Account", desc: "Secure your profile with username & password" },
    { icon: <HeartFilled />, title: "Complete Profile", desc: "Help us find your perfect match" },
  ];

  return (
    <>
      <div className="reg-page-wrapper">
        <LoginHeader />
        <div className="reg-page-overlay" />

        {["💖", "💍", "💕", "🌹", "💗", "💝", "🌸", "💌", "🎀", "❤️", "💐", "✨"].map((e, i) => (
          <span key={i} className="reg-floating-emoji" style={{
            top: `${8 + ((i * 7) % 78)}%`, left: `${5 + ((i * 9) % 85)}%`, fontSize: `${18 + (i % 5) * 5}px`,
            animationDelay: `${i * 0.35}s`, animationDuration: `${3 + i * 0.4}s`,
          }}>{e}</span>
        ))}

        <div className="reg-content-wrapper">
          <h1 className="reg-page-title">
            <span className="reg-beat">💖</span> Find Your Perfect Match <span className="reg-beat">💖</span>
          </h1>
          <p className="reg-page-subtitle">Create your profile and begin your beautiful journey</p>

          <div className="reg-steps-bar">
            <Steps current={phone_pop} className="reg-steps" direction="horizontal" responsive={false} labelPlacement="vertical" size="small"
              items={[
                { title: "Mobile", icon: phone_pop > 0 ? <CheckCircleFilled /> : <MobileOutlined /> },
                { title: "Verify", icon: phone_pop > 1 ? <CheckCircleFilled /> : <SafetyOutlined /> },
                { title: "Account", icon: phone_pop > 2 ? <CheckCircleFilled /> : <LockOutlined /> },
                { title: "Profile", icon: phone_pop > 3 ? <CheckCircleFilled /> : <HeartFilled /> },
              ]}
            />
          </div>

          <div className="reg-anim">
            <Card className="reg-main-card" bodyStyle={{ padding: 0 }}>
              <div className="reg-shimmer-bar" />
              <div className="reg-form reg-form-container">

                {phone_pop < 3 && (
                  <div className="reg-step-icon-wrap">
                    <div className={`reg-step-icon ${phone_pop === 0 ? 'pulse' : ''}`}>{stepTitles[phone_pop].icon}</div>
                    <h2 className="reg-step-title"><HeartFilled style={{ color: "#ff0055", marginRight: 8 }} />{stepTitles[phone_pop].title}</h2>
                    <p className="reg-step-desc">{stepTitles[phone_pop].desc}</p>
                  </div>
                )}

                {phone_pop === 3 && (
                  <div className="reg-step-icon-wrap">
                    <div className="reg-final-badge"><StarFilled /> Final Step</div>
                    <h2 className="reg-step-title"><HeartFilled className="reg-beat" style={{ color: "#ff0055", marginRight: 8 }} />Complete Your Profile</h2>
                    <p className="reg-step-desc">Help us find your perfect match</p>
                  </div>
                )}

                {/* STEP 0 - Phone Form */}
                {phone_pop === 0 && (
                  <Spin spinning={isLoading} tip="Sending OTP...">
                    <div style={{ maxWidth: 480, margin: "0 auto" }}>
                      <div className="reg-trust-strip"><SafetyOutlined style={{ color: "#ff0055", fontSize: 18 }} /><span className="reg-trust-strip-text">Your number is safe &amp; never shared</span></div>
                      <div className="reg-inner-box">
                        <Form form={phoneForm} onFinish={send} layout="vertical" requiredMark={false}>
                          <Form.Item name="contact" label="Mobile Number" rules={[{ required: true, message: "Please enter your mobile number" }, { pattern: /^[0-9]{10}$/, message: "Must be exactly 10 digits" }]}>
                            <Input prefix={<MobileOutlined />} type="tel" placeholder="Enter 10-digit mobile number" maxLength={10} disabled={isLoading} onChange={(e) => { const clean = e.target.value.replace(/\D/g, "").slice(0, 10); phoneForm.setFieldsValue({ contact: clean }); }} />
                          </Form.Item>
                          <Form.Item style={{ marginBottom: 0 }}>
                            <Button htmlType="submit" loading={isLoading} className="reg-btn reg-primary-btn">Send OTP <ArrowRightOutlined /></Button>
                          </Form.Item>
                        </Form>
                      </div>
                      <div className="reg-trust-badges">{["100% Secure", "Verified Profiles"].map(t => <span key={t} className="reg-trust-badge"><CheckCircleFilled /> {t}</span>)}</div>
                    </div>
                  </Spin>
                )}

                {/* STEP 1 - OTP Form */}
                {phone_pop === 1 && (
                  <Spin spinning={isLoading} tip="Verifying...">
                    <div style={{ maxWidth: 480, margin: "0 auto" }}>
                      <div className="reg-inner-box">
                        <Form form={otpForm} onFinish={verify} layout="vertical">
                          <Form.Item name="contact" label="Sent to"><Input prefix={<MobileOutlined />} readOnly className="reg-verified-input" /></Form.Item>
                          <Form.Item name="otp" label="One-Time Password" rules={[{ required: true, message: "Please enter your OTP" }]}>
                            <Input.OTP length={6} />
                          </Form.Item>
                          <Form.Item style={{ marginBottom: 0 }}>
                            <Button htmlType="submit" loading={isLoading} className="reg-btn reg-primary-btn">Verify &amp; Continue <ArrowRightOutlined /></Button>
                          </Form.Item>
                        </Form>
                      </div>
                      <div className="reg-change-link"><Button type="link" onClick={() => setPhone_pop(0)} className="reg-change-btn">← Change Number</Button></div>
                    </div>
                  </Spin>
                )}

                {/* STEP 2 - Username Form */}
                {phone_pop === 2 && (
                  <div style={{ maxWidth: 500, margin: "0 auto" }}>
                    <div className="reg-inner-box">
                      <Form form={usernameForm} onFinish={handleUsernameSubmit} layout="vertical" requiredMark={false}>
                        <Form.Item label="Username" name="username"
                          rules={[
                            { required: true, message: "Please enter your username" },
                            { min: 4, max: 16, message: "Must be between 4 and 16 characters" },
                            { pattern: /^[a-z0-9]+$/, message: "Only lowercase alphanumeric allowed" },
                            () => ({
                              validator(_, value) {
                                if (!value) return Promise.resolve();
                                if (usernameStatus.checking) return Promise.reject(new Error('⏳ Checking availability...'));
                                if (usernameStatus.validated && usernameStatus.available) return Promise.resolve();
                                if (usernameStatus.validated && !usernameStatus.available) return Promise.reject(new Error('❌ Username already taken'));
                                return Promise.reject(new Error('Please wait for availability check'));
                              },
                            }),
                          ]}
                          validateStatus={usernameStatus.checking ? 'validating' : usernameStatus.validated && usernameStatus.available ? 'success' : usernameStatus.validated && !usernameStatus.available ? 'error' : ''}
                          help={usernameStatus.checking ? '⏳ Checking...' : usernameStatus.validated && usernameStatus.available ? '✅ Available!' : usernameStatus.validated && !usernameStatus.available ? '❌ Already taken.' : 'Enter a unique username (min 4 characters)'}
                        >
                          <Input prefix={<UserOutlined />} placeholder="Choose a unique username" onChange={handleUsernameChange} autoComplete="off" autoCorrect="off" autoCapitalize="off" suffix={usernameStatus.available && usernameStatus.validated ? <CheckCircleOutlined style={{ color: '#52c41a' }} /> : usernameStatus.validated && !usernameStatus.available ? <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} /> : null} />
                        </Form.Item>

                        <Form.Item name="password" label="Password" hasFeedback extra="Min 8 chars with uppercase & number"
                          rules={[
                            { required: true, message: "Please create a password!" },
                            { min: 8, message: "Minimum 8 characters" },
                            { pattern: /[A-Z]/, message: "Requires at least one uppercase letter" },
                            { pattern: /[0-9]/, message: "Requires at least one number" },
                          ]}>
                          <Input.Password prefix={<LockOutlined />} placeholder="Create strong password" autoComplete="new-password" />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
                          <Button htmlType="submit" loading={isLoading} className="reg-btn reg-primary-btn" disabled={!usernameStatus.available || !usernameStatus.validated}>Continue <ArrowRightOutlined /></Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                )}

                {/* ✅ STEP 3 - Profile Form WITH VALIDATIONS */}
                {phone_pop === 3 && (
                  <Spin spinning={isLoading} tip="Saving profile...">
                    <div style={{ background: '#fff', border: '2px solid #ffe4ec', borderRadius: 16, padding: '16px 20px', marginBottom: 24, position: 'sticky', top: 0, zIndex: 10, boxShadow: '0 4px 12px rgba(255,0,85,.06)' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#1a0a10' }}>📊 Profile Completion</span>
                        <span style={{ fontSize: 18, fontWeight: 900, color: formProgress >= 80 ? '#4caf50' : formProgress >= 50 ? '#ff9800' : '#ff0055' }}>{formProgress}%</span>
                      </div>
                      <div style={{ width: '100%', height: 10, background: '#fff0f3', borderRadius: 999, overflow: 'hidden' }}>
                        <div style={{ width: `${formProgress}%`, height: '100%', borderRadius: 999, background: formProgress >= 80 ? 'linear-gradient(90deg, #4caf50, #66bb6a)' : formProgress >= 50 ? 'linear-gradient(90deg, #ff9800, #ffb74d)' : 'linear-gradient(90deg, #ff0055, #ff4d88)', transition: 'width 0.5s ease' }} />
                      </div>
                      <p style={{ fontSize: 11, color: '#999', margin: '8px 0 0', textAlign: 'center' }}>
                        {formProgress < 30 ? '🚀 Start filling your profile details' : formProgress < 50 ? '📝 Good start! Keep adding more' : formProgress < 70 ? '💪 Halfway there!' : formProgress < 90 ? '🎯 Almost done!' : '🎉 Your profile is almost complete!'}
                      </p>
                    </div>

                    <Form
                      form={profileForm}
                      onFinish={profile_details}
                      onFinishFailed={handleProfileFinishFailed}
                      layout="vertical"
                      requiredMark={false}
                      onValuesChange={calculateProgress}
                    >
                      <div className="reg-photo-wrap">
                        <Upload beforeUpload={(f) => { setFile(f); setPreviewUrl(URL.createObjectURL(f)); return false; }} showUploadList={false}>
                          <div className="reg-upload reg-photo-upload">
                            {previewUrl ? <img src={previewUrl} alt="preview" className="reg-photo-preview" /> : <><CameraOutlined style={{ fontSize: 28, color: "#ff0055", marginBottom: 6 }} /><span style={{ fontSize: 12, color: "#ff4d88", fontWeight: 600 }}>Add Photo</span></>}
                          </div>
                        </Upload>
                        <p className="reg-photo-hint">📸 Upload your best photo</p>
                      </div>

                      {/* PERSONAL DETAILS */}
                      <div className="reg-section">
                        <div className="reg-section-header">
                          <span className="reg-section-icon">👤</span>
                          <div>
                            <h3 className="reg-section-title">Personal Details</h3>
                            <p className="reg-section-sub">Basic information about you</p>
                          </div>
                        </div>
                        <div className="reg-grid">
                          <Form.Item name="firstname" label={<span>Full Name <span className="reg-required-star">*</span></span>}
                            rules={[{ required: true, message: "Full Name is required" }]}>
                            <Input placeholder="Enter Full Name" />
                          </Form.Item>

                          <Form.Item name="gender" label={<span>Gender <span className="reg-required-star">*</span></span>}
                            rules={[{ required: true, message: "Gender is required" }]}>
                            <Select placeholder="Select Gender" allowClear>
                              <Option value="Male">👨 Male</Option>
                              <Option value="Female">👩 Female</Option>
                            </Select>
                          </Form.Item>

                          <Form.Item name="dob" label={<span>Date of Birth <span className="reg-required-star">*</span></span>}
                            rules={[
                              { required: true, message: "Date of birth is required" },
                              {
                                validator: (_, value) => {
                                  if (!value) return Promise.resolve();
                                  const dob = new Date(value); const today = new Date();
                                  let age = today.getFullYear() - dob.getFullYear();
                                  const m = today.getMonth() - dob.getMonth();
                                  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
                                  if (dob > today) return Promise.reject(new Error("❌ Cannot be future date"));
                                  if (age < 18) return Promise.reject(new Error("❌ Must be at least 18 years old"));
                                  return Promise.resolve();
                                },
                              },
                            ]}>
                            <Input type="date" style={{ width: "100%" }} max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split("T")[0]} />
                          </Form.Item>

                          <Form.Item name="marrige_status" label={<span>Marital Status <span className="reg-required-star">*</span></span>} initialValue="Unmarried"
                            rules={[{ required: true, message: "Marital Status is required" }]}>
                            <Select placeholder="Select Status" allowClear>
                              <Option value="Unmarried">💑 Unmarried</Option>
                              <Option value="Divorced">💔 Divorced</Option>
                              <Option value="Widowed">🕊️ Widowed</Option>
                            </Select>
                          </Form.Item>

                          {/* YAHAN EMAIL REQUIRED KIYA GAYA HAI */}
                          <Form.Item
                            name="email"
                            label={<span>Email Address <span className="reg-required-star">*</span></span>}
                            rules={[
                              { required: true, message: "Email is required" },
                              { type: "email", message: "❌ Please enter a valid email format" },
                            ]}
                            validateStatus={emailStatus.checking ? "validating" : emailStatus.validated && emailStatus.available ? "success" : emailStatus.validated && !emailStatus.available ? "error" : ""}
                            help={emailStatus.checking ? "⏳ Checking availability..." : emailStatus.validated && emailStatus.available ? "✅ Email available" : emailStatus.validated && !emailStatus.available ? emailStatus.message : "Required for communication"}
                          >
                            <Input
                              type="email"
                              placeholder="Enter Email Address"
                              onChange={handleEmailChange}
                              suffix={emailStatus.checking ? null : emailStatus.validated && emailStatus.available ? <CheckCircleOutlined style={{ color: "#52c41a" }} /> : emailStatus.validated && !emailStatus.available ? <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} /> : null}
                            />
                          </Form.Item>

                          <Form.Item name="height" label="Height">
                            <Select placeholder="Select Height" allowClear showSearch filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}>
                              {generateHeightOptions().map(h => <Option key={h.value} value={h.value}>{h.label}</Option>)}
                            </Select>
                          </Form.Item>

                          <Form.Item name="blood_group" label="Blood Group">
                            <Select placeholder="Select Blood Group" allowClear>
                              {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map(bg => <Option key={bg} value={bg}>{bg}</Option>)}
                            </Select>
                          </Form.Item>

                          <Form.Item name="mother_tongue" label="Mother Tongue">
                            <Select placeholder="Select Mother Tongue" allowClear showSearch>
                              {["Hindi", "English", "Marathi", "Punjabi", "Gujarati", "Bengali", "Tamil", "Telugu", "Kannada", "Malayalam", "Odia", "Assamese", "Urdu"].map(l => <Option key={l} value={l}>{l}</Option>)}
                            </Select>
                          </Form.Item>

                          <Form.Item name="foodLifestyle" label="Food Lifestyle">
                            <Select placeholder="Select Food Lifestyle" allowClear>
                              <Option value="vegetarian">🥗 Vegetarian</Option>
                              <Option value="non_vegetarian">🍗 Non-Vegetarian</Option>
                              <Option value="eggetarian">🥚 Eggetarian</Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>

                      {/* LOCATION */}
                      <div className="reg-section">
                        <div className="reg-section-header">
                          <span className="reg-section-icon">📍</span>
                          <div>
                            <h3 className="reg-section-title">Location Details</h3>
                            <p className="reg-section-sub">Where do you live?</p>
                          </div>
                        </div>
                        <div className="reg-grid">
                          <Form.Item name="state" label={<span>State <span className="reg-required-star">*</span></span>}
                            rules={[{ required: true, message: "State is required" }]}>
                            <Select placeholder="Select State" allowClear showSearch onChange={handleStateChange} filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                              {state.map((s) => <Option key={s.state} value={s.state}>{s.state}</Option>)}
                            </Select>
                          </Form.Item>

                          <Form.Item name="disttrict" label={<span>District <span className="reg-required-star">*</span></span>}
                            rules={[{ required: true, message: "District is required" }]}>
                            <Select placeholder={districts.length ? "Select District" : "Select State first"} allowClear showSearch onChange={handleDistrictChange} disabled={!districts.length} filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                              {districts.map((d) => <Option key={d} value={d}>{d}</Option>)}
                            </Select>
                          </Form.Item>

                          <Form.Item name="city" label={<span>City <span className="reg-required-star">*</span></span>}
                            rules={[
                              { required: true, message: "City is required" },
                              { pattern: /^[a-zA-Z\s\-.'"]+$/, message: "Please enter a valid city name" }
                            ]}>
                            <Input placeholder="Enter your city name" allowClear />
                          </Form.Item>

                          <Form.Item
                            name="contact1"
                            label="Alternate Mobile Number"
                            normalize={(value) => value?.replace(/\D/g, '').slice(0, 10)} // 👈 1. Sirf numbers rakhega & 10 digits par rok dega
                            rules={[
                              { pattern: /^[0-9]{10}$/, message: "Must be exactly 10 digits" }
                            ]}
                          >
                            <Input
                              placeholder="Alternate Number (Optional)"
                              maxLength={10}
                              inputMode="numeric" 
                            />
                          </Form.Item>
                        </div>
                      </div>

                      {/* RELIGION & CASTE */}
                      <div className="reg-section">
                        <div className="reg-section-header">
                          <span className="reg-section-icon">🕉️</span>
                          <div>
                            <h3 className="reg-section-title">Religion & Caste</h3>
                            <p className="reg-section-sub">Your religious background</p>
                          </div>
                        </div>
                        <div className="reg-grid">
                          <Form.Item name="religion" label={<span>Religion <span className="reg-required-star">*</span></span>}
                            rules={[{ required: true, message: "Religion is required" }]}>
                            <Select placeholder="Select Religion" allowClear showSearch onChange={handlereligionChange} filterOption={(input, option) => (option?.children?.toLowerCase() || '').includes(input.toLowerCase())}>
                              {religionOptions.map((r) => <Option key={r.id} value={r.value}>{r.emoji} {r.label}</Option>)}
                            </Select>
                          </Form.Item>

                          <Form.Item name="caste" label={<span>Caste <span className="reg-required-star">*</span></span>}
                            rules={[{ required: true, message: "Caste is required" }]}>
                            <AutoComplete placeholder={filteredCastes.length ? "Select or type your caste" : "Select Religion first"} allowClear options={filteredCastes.map(c => ({ value: c.name || c, label: c.name || c }))} filterOption={(input, option) => (option?.value || '').toLowerCase().includes(input.toLowerCase())} notFoundContent={<div style={{ padding: 8, color: '#ff0055', fontSize: 12, textAlign: 'center' }}>✍️ Type your caste</div>} style={{ width: '100%' }} />
                          </Form.Item>

                          <Form.Item name="subcaste" label="Sub Caste">
                            <Input placeholder="Enter Sub Caste (Optional)" />
                          </Form.Item>
                        </div>
                      </div>

                      {/* FAMILY */}
                      <div className="reg-section">
                        <div className="reg-section-header">
                          <span className="reg-section-icon">👨‍👩‍👧‍👦</span>
                          <div>
                            <h3 className="reg-section-title">Family Details</h3>
                            <p className="reg-section-sub">Tell us about your family</p>
                          </div>
                        </div>
                        <div className="reg-grid">
                          <Form.Item name="father_name" label="Father's Name"><Input placeholder="Enter Father's Name" /></Form.Item>
                          <Form.Item name="father_occupation" label="Father's Occupation"><Select placeholder="Select" allowClear showSearch>{fatherOccupationOptions.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item>
                          <Form.Item name="mother_name" label="Mother's Name"><Input placeholder="Enter Mother's Name" /></Form.Item>
                          <Form.Item name="mother_occupation" label="Mother's Occupation"><Select placeholder="Select" allowClear showSearch>{occupationOptions.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item>

                          <Form.Item name="brother" label="No. of Brothers" initialValue={0}><Input type="number" placeholder="0" min={0} max={20} onChange={(e) => { const totalBro = Number(e.target.value) || 0; const marriedBro = Number(profileForm.getFieldValue('brother_marrige')) || 0; if (marriedBro > totalBro) profileForm.setFieldsValue({ brother_marrige: totalBro }); }} /></Form.Item>
                          <Form.Item name="brother_marrige" label="Married Brothers" initialValue={0} dependencies={['brother']} rules={[{ validator(_, value) { if (value === undefined || value === null || value === '') return Promise.resolve(); const married = Number(value); const total = Number(profileForm.getFieldValue('brother')) || 0; if (married < 0) return Promise.reject(new Error("❌ Cannot be negative")); if (married > total) return Promise.reject(new Error(`❌ Cannot exceed total brothers (${total})`)); return Promise.resolve(); } }]}><Input type="number" placeholder="0" min={0} /></Form.Item>
                          <Form.Item name="sister" label="No. of Sisters" initialValue={0}><Input type="number" placeholder="0" min={0} max={20} onChange={(e) => { const totalSis = Number(e.target.value) || 0; const marriedSis = Number(profileForm.getFieldValue('sister_marrige')) || 0; if (marriedSis > totalSis) profileForm.setFieldsValue({ sister_marrige: totalSis }); }} /></Form.Item>
                          <Form.Item name="sister_marrige" label="Married Sisters" initialValue={0} dependencies={['sister']} rules={[{ validator(_, value) { if (value === undefined || value === null || value === '') return Promise.resolve(); const married = Number(value); const total = Number(profileForm.getFieldValue('sister')) || 0; if (married < 0) return Promise.reject(new Error("❌ Cannot be negative")); if (married > total) return Promise.reject(new Error(`❌ Cannot exceed total sisters (${total})`)); return Promise.resolve(); } }]}><Input type="number" placeholder="0" min={0} /></Form.Item>
                        </div>
                      </div>

                      {/* EDUCATION */}
                      <div className="reg-section">
                        <div className="reg-section-header">
                          <span className="reg-section-icon">🎓</span>
                          <div>
                            <h3 className="reg-section-title">Education & Career</h3>
                            <p className="reg-section-sub">Your qualifications and profession</p>
                          </div>
                        </div>
                        <div className="reg-grid">
                          <Form.Item name="university" label="University / College"><Input placeholder="Enter University Name" /></Form.Item>
                          <Form.Item name="course" label="Highest Qualification"><Select placeholder="Select Course" allowClear showSearch onChange={handleCourseChange}>{Object.keys(subCourseData).map(c => <Option key={c} value={c}>{c}</Option>)}</Select></Form.Item>
                          <Form.Item name="sub_course" label="Specialization">{isOtherCourse ? <Input placeholder="Enter specialization" value={otherSubCourse} onChange={(e) => { setOtherSubCourse(e.target.value); profileForm.setFieldsValue({ sub_course: e.target.value }); }} /> : <Select placeholder={subCourses.length ? "Select Specialization" : "Select Course first"} allowClear showSearch disabled={!subCourses.length}>{subCourses.map(s => <Option key={s} value={s}>{s}</Option>)}</Select>}</Form.Item>
                          <Form.Item name="job_title" label="Job / Profession"><Input placeholder="Enter Job Title" /></Form.Item>
                          <Form.Item name="job_type" label="Employment Type"><Select placeholder="Select Type" allowClear><Option value="Govt">🏛️ Government</Option><Option value="Pvt">🏢 Private</Option><Option value="Self">👤 Self Employed</Option><Option value="Not Working">📭 Not Working</Option></Select></Form.Item>
                          <Form.Item name="annual_income" label="Annual Income (₹)"><Input type="number" placeholder="e.g. 500000" /></Form.Item>
                          <Form.Item name="Lifestyle" label="Lifestyle"><Input placeholder="Enter Lifestyle" /></Form.Item>
                        </div>
                      </div>

                      {/* ADDITIONAL */}
                      <div className="reg-section">
                        <div className="reg-section-header">
                          <span className="reg-section-icon">📝</span>
                          <div>
                            <h3 className="reg-section-title">Additional Information</h3>
                            <p className="reg-section-sub">Optional details</p>
                          </div>
                        </div>
                        <div className="reg-grid">
                          <Form.Item name="created_profile" label="Profile Managed By">
                            <Select placeholder="Select" allowClear>
                              <Option value="self">👤 Self</Option>
                              <Option value="son">👦 Son</Option>
                              <Option value="daughter">👧 Daughter</Option>
                              <Option value="sister">👩 Sister</Option>
                              <Option value="friend">🤝 Friend</Option>
                              <Option value="other">👥 Other</Option>
                            </Select>
                          </Form.Item>
                        </div>

                        <div className="reg-additional-row">
                          <div className="reg-additional-col">
                            <div className="reg-compact-box">
                              <div className="reg-compact-header">
                                <span className="reg-compact-label">📝 About Yourself</span>
                                <span className="reg-compact-badge">Optional</span>
                              </div>
                              <Form.Item name="additional_notes" style={{ marginBottom: 0 }}>
                                <Input.TextArea className="reg-compact-input reg-compact-textarea" maxLength={500} autoSize={{ minRows: 1, maxRows: 3 }} placeholder="Write something about yourself..." />
                              </Form.Item>
                            </div>
                          </div>

                          <div className="reg-additional-col">
                            <div className="reg-compact-box">
                              <div className="reg-compact-header">
                                <span className="reg-compact-label"><GiftOutlined /> Referral Code</span>
                                <span className="reg-compact-badge">Optional</span>
                              </div>
                              <Form.Item name="referral_code" style={{ marginBottom: 0 }}
                                validateStatus={referralStatus.checking ? 'validating' : referralStatus.validated && referralStatus.valid ? 'success' : referralStatus.validated && !referralStatus.valid && referralStatus.message ? 'error' : ''}
                                help={referralStatus.checking ? '⏳ Checking...' : referralStatus.validated && referralStatus.valid ? referralStatus.message : referralStatus.validated && !referralStatus.valid && referralStatus.message ? referralStatus.message : '💡 Enter a staff ID or CR code'}>
                                <Input placeholder="e.g., CR123456 or 123456" className="reg-compact-input" maxLength={20} onChange={handleReferralChange} disabled={referralStatus.checking} suffix={referralStatus.validated && referralStatus.valid ? <CheckCircleOutlined style={{ color: '#52c41a' }} /> : referralStatus.validated && !referralStatus.valid && referralStatus.message ? <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} /> : null} />
                              </Form.Item>
                              {referralStatus.valid && referralStatus.referrerData && (
                                <div style={{ marginTop: 8, padding: '8px 12px', background: '#e8f5e9', borderRadius: 6, fontSize: 12, color: '#2e7d32', display: 'flex', alignItems: 'center', gap: 8 }}>
                                  <span>👤</span>
                                  <span>Referred by: <strong>{referralStatus.referrerData.first_name || referralStatus.referrerData.username || 'Staff'}</strong> {referralStatus.referrerData.role && ` (${referralStatus.referrerData.role})`}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* SUBMIT */}
                      <div style={{ textAlign: "center", marginTop: 32 }}>
                        <Button htmlType="submit" loading={isLoading} className="reg-btn reg-final-btn">
                          <HeartFilled style={{ marginRight: 8 }} /> Save Profile
                        </Button>
                        <div className="reg-trust-badges" style={{ marginTop: 20 }}>
                          {["Secure", "Private", "Verified"].map(t => <span key={t} className="reg-trust-badge"><CheckCircleFilled /> {t}</span>)}
                        </div>
                      </div>
                    </Form>
                  </Spin>
                )}

              </div>
            </Card>
          </div>

          <div className="reg-bottom-badges">
            {[
              { icon: "🔒", text: "SSL Secure" },
              { icon: "✅", text: "Verified Profiles" },
              { icon: "🛡️", text: "Privacy Protected" },
              { icon: "💑", text: "10,000+ Matches" },
            ].map((item, i) => (
              <div key={i} className="reg-bottom-badge">
                <span className="reg-bottom-badge-icon">{item.icon}</span>
                {item.text}
              </div>
            ))}
          </div>
        </div >
      </div >
      <Footer />
    </>
  );
}

export default User_Reg;